import ProductImages1 from "./productImages1.png";
import ProductImages2 from "./productImages2.jpg";

export const ProductImage = {
  Copy: ProductImages1,
  Image: ProductImages2,
};
